__turbopack_context__.v({
  "active": "conversation-module-sass-module__7T0_0G__active",
  "checkbox": "conversation-module-sass-module__7T0_0G__checkbox",
  "date": "conversation-module-sass-module__7T0_0G__date",
  "formDiv": "conversation-module-sass-module__7T0_0G__formDiv",
  "fromDiv": "conversation-module-sass-module__7T0_0G__fromDiv",
  "message": "conversation-module-sass-module__7T0_0G__message",
  "new": "conversation-module-sass-module__7T0_0G__new",
  "subjectDiv": "conversation-module-sass-module__7T0_0G__subjectDiv",
  "username": "conversation-module-sass-module__7T0_0G__username",
});
